export const specialStreetNameList = [
  {
    shortName: "St",
    longName: "Saint"
  }
]
